module.exports = "<div [hidden]=\"!chartPie\"><canvas id=\"chartPie\"></canvas></div>\n"